/* eslint-disable react/prop-types */
import React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import styles from './ShopDetailsPage.module.scss';
import { getCategoryLink, getSubCategoryFullSlug } from './sdpUtils';
import clickoutScript from '../../utils/clickoutScript';
import { Link } from 'react-router-dom';
import { getPagePath } from '../../utils/appRoutes';
import { ARD_SEARCH } from '../../utils/appRoutes.definitions';

const SDPAssortment = ({ shopInfo, clickout, intlFull }) => {
  const assortment = shopInfo?.tops?.assortment?.buckets.map((category) => ({
    ...category,
    url: getSubCategoryFullSlug(category),
  }));
  const assortmentTotalAmount = shopInfo?.tops?.hits?.total?.value;

  return (
    assortment?.length > 2 && (
      <div className={classNames(styles.assortment)}>
        <h2>
          <FormattedMessage id="shop.assortmentHeader" defaultMessage="Assortment" />
        </h2>
        <p>
          <FormattedMessage
            defaultMessage="At this shop you will find an extensive range of branded products."
            id="shop.assortmentText"
            values={{
              shopName: shopInfo.shop_name,
              productsAmount: assortmentTotalAmount,
              shopLink: (
                <a
                  onClick={() => clickoutScript(shopInfo.shop_link, clickout, false)}
                  href={clickoutScript(shopInfo.shop_link, clickout, true)}
                  target="_blank"
                  rel="noreferrer"
                >
                  {shopInfo.shop_name}
                </a>
              ),
              assortmentList: intlFull.formatList(
                assortment.map(({ key, url }) => getCategoryLink(key, url, shopInfo.shop_name)),
                { type: 'conjunction' }
              ),
            }}
          />
          <Link to={`${getPagePath(ARD_SEARCH)}?webshop=${encodeURIComponent(shopInfo.shop_name)}`}>
            <FormattedMessage
              id="shop.assortmentShopLink"
              defaultMessage="Link to shop"
              values={{ shopName: shopInfo.shop_name }}
            />
          </Link>
          .
        </p>
      </div>
    )
  );
};

export default SDPAssortment;
